import CleanSlateDashboard from "./pages/CleanSlateDashboard";
import CleanSlateUpload from "./pages/CleanSlateUpload";
import Scan from "./pages/Scan";
import Contact from "./pages/Contact";
import DMCAPolicy from "./pages/DMCAPolicy";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Signup from "./pages/Signup";
import FingerprintFinder from "./pages/FingerprintFinder";
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Leaks from './pages/Leaks';
import MastersUpload from './pages/MastersUpload';
import Settings from './pages/Settings';
import Pricing from './pages/Pricing';
import Review from './pages/Review';
import Insights from './pages/Insights';
import Analytics from './pages/Analytics';
import Admin from './pages/Admin';
import AdminLeaks from './pages/AdminLeaks';
import AdminSweepReview from './pages/AdminSweepReview';
import TakedownTracker from './pages/TakedownTracker';
import ForgotPassword from './pages/ForgotPassword';
import FaceProtect from './FaceProtect';
import ResetPassword from './pages/ResetPassword';
import PpvUpload from './pages/PpvUpload';
import PpvPublic from './pages/PpvPublic';
import VaultLogin from './pages/VaultLogin';
import VaultVerify from './pages/VaultVerify';
import MyPurchases from './pages/MyPurchases';
import CreatorStorefront from './pages/CreatorStorefront';
import VaultDirectLanding from './pages/VaultDirectLanding';
import Help from './pages/Help';
import LeakReport from './pages/LeakReport';
import AffiliateJoin from './pages/AffiliateJoin';
import AffiliateLogin from './pages/AffiliateLogin';
import AffiliateVerify from './pages/AffiliateVerify';
import AffiliateDashboard from './pages/AffiliateDashboard';
import IntelligenceLogin from './pages/IntelligenceLogin';
import IntelligenceWorkspace from './pages/IntelligenceWorkspace';
import IntelligenceReview from './pages/IntelligenceReview';
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('tribal_token');
  return token ? children : <Navigate to="/login" />;
};

// Specialist-only gate. Distinct token key (tribal_staff_token) so a
// creator session can't accidentally let a staff route through and a
// staff session can't satisfy PrivateRoute either. Frontend mirror of
// the backend's kind:'staff' structural separator.
const SpecialistPrivateRoute = ({ children }) => {
  const token = localStorage.getItem('tribal_staff_token');
  return token ? children : <Navigate to="/intelligence/login" />;
};

function CleanSlateRouter() {
  const user = JSON.parse(localStorage.getItem("tribal_user") || "{}");
  if (user.plan === "clean_slate") return <CleanSlateDashboard />;
  return <Dashboard />;
}

// vaultdirect.io serves a buyer-marketplace route set: landing
// page at /, creator storefront at /:username, buyer vault at
// /vault/*. Other domains (creatorprotect.io etc.) keep the full
// creator-facing app. Detect at render time so a single build
// serves both domains.
function isVaultDirectHost() {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.includes('vaultdirect');
}

function VaultDirectRoutes() {
  return (
    <Routes>
      <Route path="/"                   element={<VaultDirectLanding />} />
      <Route path="/vault"              element={<Navigate to="/vault/login" replace />} />
      <Route path="/vault/login"        element={<VaultLogin />} />
      <Route path="/vault/verify"       element={<VaultVerify />} />
      <Route path="/vault/my-purchases" element={<MyPurchases />} />
      {/* Keep the old /vault/:username path working so existing
          affiliate links don't break. */}
      <Route path="/vault/:username"    element={<CreatorStorefront />} />
      <Route path="/ppv/:id"            element={<PpvPublic />} />
      {/* Catch-all creator storefront. Must come LAST so static
          routes above take priority. */}
      <Route path="/:username"          element={<CreatorStorefront />} />
    </Routes>
  );
}

function CreatorProtectRoutes() {
  return (
    <Routes>
      <Route path="/landing" element={<Landing />} />
      <Route path="/login"    element={<Login />} />
      <Route path="/signup"   element={<Signup />} />
      <Route path="/pricing"  element={<Pricing />} />
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<PrivateRoute><CleanSlateRouter /></PrivateRoute>} />
      <Route path="/leaks"    element={<PrivateRoute><Leaks /></PrivateRoute>} />
      <Route path="/upload"   element={<PrivateRoute><MastersUpload /></PrivateRoute>} />
      <Route path="/face-protect" element={<PrivateRoute><FaceProtect creatorId={JSON.parse(localStorage.getItem('tribal_user') || '{}').id} /></PrivateRoute>} />
      <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
      <Route path="/review" element={<PrivateRoute><Review /></PrivateRoute>} />
      <Route path="/insights" element={<PrivateRoute><Insights /></PrivateRoute>} />
      <Route path="/analytics" element={<PrivateRoute><Analytics /></PrivateRoute>} />
      <Route path="/fingerprint" element={<PrivateRoute><FingerprintFinder /></PrivateRoute>} />
      <Route path="/cs-upload"   element={<PrivateRoute><CleanSlateUpload /></PrivateRoute>} />
      <Route path="/scan" element={<Scan />} />
      <Route path="/privacy"     element={<Privacy />} />
      <Route path="/terms"       element={<Terms />} />
      <Route path="/dmca"        element={<DMCAPolicy />} />
      <Route path="/contact"     element={<Contact />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/leaks" element={<AdminLeaks />} />
      <Route path="/admin/leaks/:creatorId" element={<AdminLeaks />} />
      <Route path="/admin/sweep-review" element={<AdminSweepReview />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/tracker" element={<PrivateRoute><TakedownTracker /></PrivateRoute>} />
      <Route path="/help"    element={<PrivateRoute><Help /></PrivateRoute>} />
      <Route path="/reports/:token" element={<LeakReport />} />
      <Route path="/ppv/:id"       element={<PpvPublic />} />
      <Route path="/ppv-upload"    element={<PrivateRoute><PpvUpload /></PrivateRoute>} />
      <Route path="/ppv-dashboard" element={<Navigate to="/dashboard?tab=vault" replace />} />
      <Route path="/vault"              element={<Navigate to="/vault/login" replace />} />
      <Route path="/vault/login"        element={<VaultLogin />} />
      <Route path="/vault/verify"       element={<VaultVerify />} />
      <Route path="/vault/my-purchases" element={<MyPurchases />} />
      <Route path="/vault/:username"    element={<CreatorStorefront />} />
      <Route path="/affiliate"          element={<Navigate to="/affiliate/login" replace />} />
      <Route path="/affiliate/join"     element={<AffiliateJoin />} />
      <Route path="/affiliate/login"    element={<AffiliateLogin />} />
      <Route path="/affiliate/verify"   element={<AffiliateVerify />} />
      <Route path="/affiliate/dashboard" element={<AffiliateDashboard />} />
      <Route path="/intelligence/login" element={<IntelligenceLogin />} />
      <Route path="/intelligence"       element={<SpecialistPrivateRoute><IntelligenceWorkspace /></SpecialistPrivateRoute>} />
      <Route path="/intelligence/review/:leakId" element={<SpecialistPrivateRoute><IntelligenceReview /></SpecialistPrivateRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      {isVaultDirectHost() ? <VaultDirectRoutes /> : <CreatorProtectRoutes />}
    </Router>
  );
}
// build Wed Apr 15 04:46:18 EDT 2026
